import React from "react";
import ProjectList from "../../newComponents/projectList";
import { useQuery } from "@apollo/client";
import SectionListing from "../../newComponents/sectionListing";
import { HandleQuery, LatestProjectData } from "../../../queries";

// Component simply returns latest 5 projects. Static query means we can't dynamically change anything like limit
const latestProjects = ({ block }) => {

    const query_state = useQuery(LatestProjectData);
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 

    return (
        <SectionListing title={"Projects"} primaryBackground="white" dataId={1}>
            <ProjectList projects={data.posts} keyBase="related-projects"/>
        </SectionListing>
    )
}

export default latestProjects;
